<template>
    <!-- 编辑界面 -->
    <el-drawer :title="title" :visible.sync="editFormVisible" @click="closeDialog" :size="600" :wrapperClosable="false"
        :modal="false" :destroy-on-close="true" class="margin_top_40">
        <el-form label-width="8.75rem" :model="editForm" ref="editForm" :rules="rules">
            <el-form-item label="所属门店" prop="storeKeyId">
                <el-select v-model="editForm.storeKeyId" placeholder="请选择门店" clearable size="small"
                    :disabled="editForm.isConfirm == true || editForm.isAudit" class="input_200px">
                    <el-option v-for="item in storeList" :label="item.value" :value="item.keyId"
                        :key="item.keyId"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="费用类型" prop="type">
                <el-select v-model="editForm.type" placeholder="请选择费用类型" clearable size="small"
                    :disabled="editForm.isConfirm == true || editForm.isAudit" class="input_200px">
                    <el-option v-for="item in typeList" :label="item.value" :value="item.keyId"
                        :key="item.keyId"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="内容" prop="content">
                <el-input v-model="editForm.content" type="textarea" :rows="3" placeholder="请输入内容" clearable
                    size="small" :disabled="editForm.isConfirm == true || editForm.isAudit"
                    class="input_200px"></el-input>
            </el-form-item>
            <el-form-item label="花费金额" prop="money">
                <el-input-number placeholder="请输入花费金额" :min="0" :precision="2" :step="0.01" size="small"
                    v-model.number="editForm.money" :disabled="editForm.isConfirm == true || editForm.isAudit"
                    class="input_200px"></el-input-number>
            </el-form-item>
            <el-form-item label="支付凭证">
                <ImageListUpload class="input_200px" v-model="fileList" :fileLimit="1" FileTypeId="storeCost"
                    :fileSize="5" @input="handleInput" :disabled="editForm.isConfirm == true || editForm.isAudit"
                    :isEdit="editForm.isConfirm == false" />
            </el-form-item>
        </el-form>
        <div class="drawer-footer">
            <el-button v-if="editForm.isConfirm == false" size="small" icon="el-icon-check" :loading="loading"
                class="title" @click="submitForm('editForm')">
                保存
            </el-button>
            <el-button size="small" icon="el-icon-delete" :loading="loading" class="title" type="danger"
                v-if="editForm.keyId != '' && this.$checkBtnPermission('/storeCost/dtl', 'delete') && editForm.isConfirm == false"
                @click="deleteForm('editForm')">
                删除
            </el-button>
            <el-button size="small" icon="el-icon-finished" :loading="loading" class="title" type="success"
                v-if="editForm.keyId != '' && this.$checkBtnPermission('/storeCost/dtl', 'confirm') && editForm.isConfirm == false"
                @click="confirmForm('editForm')">
                确认
            </el-button>
            <el-button size="small" icon="el-icon-s-check" :loading="loading" class="title" type="danger"
                v-if="editForm.keyId != '' && this.$checkBtnPermission('/storeCost/dtl', 'audit') && editForm.isPay == false && editForm.isConfirm == true && editForm.isAudit == false && editForm.money >= 200"
                @click="handleAuditClick">
                审核
            </el-button>
            <el-button size="small" icon="el-icon-finished" :loading="loading" class="title" type="primary"
                v-if="editForm.keyId != '' && this.$checkBtnPermission('/storeCost/dtl', 'pay') && editForm.isPay == false && editForm.isConfirm == true && (editForm.isAudit == true && editForm.money >= 200 || editForm.isAudit == false && editForm.money < 200)"
                @click="handlePayClick">
                确认支付
            </el-button>
        </div>
        <!-- 审核是否通过 -->
        <el-dialog :visible.sync="auditVisible" title="审核是否通过" style="width: 60%; margin: auto" append-to-body
            :close-on-click-modal="false">
            <span style="display: block; margin-bottom: 20px"><strong>审核结果:</strong></span>
            <el-radio-group v-model="auditResultInfo.isPass" style="margin-bottom: 20px;">
                <el-radio :label="true">通过</el-radio>
                <el-radio :label="false">驳回</el-radio>
            </el-radio-group>
            <span v-if="!auditResultInfo.isPass"
                style="display: block; margin-bottom: 20px"><strong>驳回原因:</strong></span>
            <el-input v-if="!auditResultInfo.isPass" v-model="auditResultInfo.reason" placeholder="请输入驳回原因"
                type="textarea" rows="4" maxlength="200" show-word-limit></el-input>
            <span slot="footer">
                <el-button @click="auditVisible = false" size="small" icon="el-icon-close">取消</el-button>
                <el-button type="primary" @click="handlePayAuditSubmit" size="small" icon="el-icon-check">确认</el-button>
            </span>
        </el-dialog>
    </el-drawer>
</template>

<script>
import {
    SaveStoreCostDtl,
    DeleteStoreCostDtl,
    ConfirmStoreCostDtl,
    GetStoreCostDtl,
    AuditStoreCostDtl,
    PayStoreCostDtl
} from "@/api/storeCostApi.js";
import ImageListUpload from '@/components/ImageListUpload.vue';
export default {
    props: ["typeList", "storeList"],
    data() {
        return {
            title: "",
            loading: false, //是显示加载
            editFormVisible: false, //控制编辑页面显示与隐藏
            editForm: {
                keyId: "",
                storeKeyId: "",
                money: 0,
                type: 1,
                content: "",
                isConfirm: false,
                filePath: '',
            },
            rules: {
                storeKeyId: [
                    {
                        required: true,
                        message: "请选择门店",
                        trigger: "blur",
                    },
                ],
                type: [
                    {
                        required: true,
                        message: "请选择费用类型",
                        trigger: "blur",
                    },
                ],
                content: [
                    {
                        required: true,
                        message: "请输入内容",
                        trigger: "blur",
                    },
                ],
                money: [
                    {
                        required: true,
                        message: "请输入花费金额",
                        trigger: "blur",
                    },
                    {
                        type: "number",
                        message: "请输入数字",
                        trigger: "blur",
                    },
                    {
                        validator: (rule, value, callback) => {
                            if (value && /\.\d{3,}/.test(value.toString())) {
                                callback(new Error('最多只能输入两位小数'));
                            } else {
                                callback();
                            }
                        },
                        trigger: "blur"
                    }
                ],
            },
            fileList: [],
            auditVisible: false,
            auditResultInfo: {
                isPass: true,
                reason: '',
            },
        };
    },
    created() {
    },
    components: {
        ImageListUpload
    },
    methods: {
        //显示编辑界面
        editShow(row) {
            this.fileList = [];
            if (row != undefined && row != "undefined") {
                this.title = "编辑";
                this.fileList = [];
                let parmer = {
                    keyId: row.keyId,
                };
                GetStoreCostDtl(parmer)
                    .then((res) => {
                        if (res.code == 1) {
                            this.editForm = res.data;
                            if (res.data.filePath) {
                                this.fileList = JSON.parse(res.data.filePath);
                            }
                            this.editFormVisible = true;
                        } else {
                            this.$message.error(res.msg);
                        }
                    })
                    .catch((err) => {
                        this.$message.error("获取备用金明细详情失败!");
                    });
            } else {
                this.title = "新增";
                this.$data.editForm = this.$options.data.call(this).editForm;
                this.editFormVisible = true;
            }
            //如果typeList第一个值为0，删除第一个值
            if (this.typeList[0].keyId == 0) {
                this.typeList.shift();
            }
        },
        // 编辑、增加页面保存方法
        submitForm(editData) {
            if (this.editForm.filePath == '') {
                this.$message.error("请上传支付凭证！");
                return;
            }
            this.$refs[editData].validate((valid) => {
                if (valid) {
                    SaveStoreCostDtl(this.editForm)
                        .then((res) => {
                            if (res.code == 1) {
                                this.$parent.getListData();
                                this.$message({
                                    type: "success",
                                    message: "备用金明细保存成功！",
                                });
                                this.editFormVisible = false;
                                this.loading = false;
                            } else {
                                this.$message({
                                    type: "info",
                                    message: res.msg,
                                });
                            }
                        })
                        .catch((err) => {
                            this.editFormVisible = false;
                            this.loading = false;
                            this.$message.error("备用金明细保存失败，请稍后再试！");
                        });
                } else {
                    return false;
                }
            });
        },
        // 关闭编辑、增加弹出框
        closeDialog() {
            this.editFormVisible = false;
            this.$data.editForm = this.$options.data.call(this).editForm;
        },
        // 删除备用金明细
        deleteForm() {
            DeleteStoreCostDtl({
                keyId: this.editForm.keyId,
            })
                .then((res) => {
                    if (res.code == 1) {
                        this.$parent.getListData();
                        this.$message({
                            type: "success",
                            message: "备用金明细删除成功！",
                        });
                        this.editFormVisible = false;
                        this.loading = false;
                    } else {
                        this.$message({
                            type: "info",
                            message: res.msg,
                        });
                    }
                })
                .catch((err) => {
                    this.editFormVisible = false;
                    this.loading = false;
                    this.$message.error("备用金明细删除失败，请稍后再试！");
                });
        },
        // 确认备用金明细
        confirmForm() {
            ConfirmStoreCostDtl({
                keyId: this.editForm.keyId,
            })
                .then((res) => {
                    if (res.code == 1) {
                        this.$parent.getListData();
                        this.$message({
                            type: "success",
                            message: "备用金明细确认成功！",
                        });
                        this.editFormVisible = false;
                        this.loading = false;
                    } else {
                        this.$message({
                            type: "info",
                            message: res.msg,
                        });
                    }
                })
                .catch((err) => {
                    this.editFormVisible = false;
                    this.loading = false;
                    this.$message.error("备用金明细确认失败，请稍后再试！");
                });
        },
        handleInput(file) {
            if (file.length > 0) {
                this.editForm.filePath = JSON.stringify(file);
            } else {
                this.editForm.filePath = '';
            }
        },
        // 审核备用金明细
        handleAuditClick() {
            if (this.editForm.isAudit == true) {
                this.$message({
                    type: "info",
                    message: "备用金明细已审核，不能重复审核！",
                });
                return;
            }
            this.loading = true;
            AuditStoreCostDtl({
                keyId: this.editForm.keyId,
            })
                .then((res) => {
                    if (res.code == 1) {
                        this.$message({
                            type: "success",
                            message: "备用金明细审核成功！",
                        });
                        this.editFormVisible = false;
                        this.$parent.getListData();
                    } else {
                        this.$message({
                            type: "info",
                            message: res.msg,
                        });
                    }
                })
                .catch((err) => {
                    this.editFormVisible = false;
                    this.loading = false;
                    this.$message.error("备用金明细审核失败，请稍后再试！");
                }).finally(() => {
                    this.loading = false;
                });
        },
        // 确认支付备用金明细
        handlePayClick() {
            if (this.editForm.isPay == true) {
                this.$message({
                    type: "info",
                    message: "备用金明细已支付，不能重复支付！",
                });
                return;
            }
            this.auditVisible = true;
        },
        // 审核支付备用金明细
        handlePayAuditSubmit() {
            this.loading = true;
            PayStoreCostDtl({
                keyId: this.editForm.keyId,
                isPass: this.auditResultInfo.isPass,
                reason: this.auditResultInfo.reason,
            }).then((res) => {
                if (res.code == 1) {
                    this.$message({
                        type: "success",
                        message: "备用金明细支付成功！",
                    });
                    this.editFormVisible = false;
                    this.$parent.getListData();
                } else {
                    this.$message({
                        type: "info",
                        message: res.msg,
                    });
                }
            })
                .catch((err) => {
                    this.editFormVisible = false;
                    this.loading = false;
                    this.$message.error("备用金明细支付失败，请稍后再试！");
                }).finally(() => {
                    this.loading = false;
                    this.auditVisible = false;
                });
        },
    },
};
</script>
<style scoped>
.wip {
    width: 200px !important;
}
</style>